import React, { Component } from "react";

const HIT_TEST_OPTIONS = {
  segments: true,
  stroke: true,
  fill: true,
  tolerance: 5
};

export default function withSelectTool(WrappedComponent) {
  return class SelectTool extends Component {
    constructor(props) {
      super(props);
      const d = props.initialData;
      const id = d && d[0] && d[0].id;
      this.state = {
        activeLayer: id,
        selectedItem: id,
        firstSelectedItem: {},
        selectedItems: []
      };
      this._changed = false;
      this._item = null;
      this._segment = null;
      this._point = null;
      this._tool = null;
      this._firstSelectedItem = null;
      this._secondSelectedItem = null;
    }

    selectItems = ({ id }) => {
      if (!this.state.selectedItems.includes(id)) {
        const items = this.state.selectedItems ? this.state.selectedItems : [];
        items.push(id);
        this.setState({ selectedItems: items });

        if (items.length == 1) {
          this._firstSelectedItem = this._item;
        } else if (items.length == 2) {
          this._secondSelectedItem = this._item;
        }
      }
    };

    deselectItems = () => {
      this._firstSelectedItem = null;
      this.setState({ selectedItems: [] });
    };

    selectItem = ({ id, type }) => {
      if (id === this.state.selectedItem) {
        return;
      }
      switch (type) {
        case "Layer":
          this.setState({ activeLayer: id, selectedItem: id });
          break;
        case "Path":
        case "Circle":
        case "Rectangle":
          this.setState({ selectedItem: id });
          break;
        default:
          break;
      }
    };

    deselectItem = () => {
      this.setState({ selectedItem: null });
    };

    keyDown = (e) => {
      if (this._item) {
        const {
          key,
          modifiers: { shift }
        } = e;
        switch (key) {
          case "delete":
            this.props.removeItem(this._item);
            this._changed = false;
            this._item = null;
            this._point = null;
            break;
          case "up":
            this._item.translate(0, shift ? -10 : -1);
            this._changed = true;
            break;
          case "down":
            this._item.translate(0, shift ? 10 : 1);
            this._changed = true;
            break;
          case "left":
            this._item.translate(shift ? -10 : -1, 0);
            this._changed = true;
            break;
          case "right":
            this._item.translate(shift ? 10 : 1, 0);
            this._changed = true;
            break;
          case "ل":
          case "g":
            this.props.groupItems(this.state.selectedItems);
            this.deselectItems();
            this.deselectItem();
          case "ث":
          case "e":
            var twoPath = [],
              selectedEl = {};
            const paper = this._tool._scope;
            this.state.selectedItems.forEach((item, index) => {
              this.props.data.layers[0].children.forEach((element) => {
                if (element.id === item) {
                  if (index === 0) {
                    selectedEl = element;
                  }
                  twoPath.push(new paper.Path(element.pathData));
                }
              });
            });

            // var newPath = twoPath[0].unite(twoPath[1])
            // var newPath = twoPath[0].intersect(twoPath[1])
            // var newPath = twoPath[0].subtract(twoPath[1])
            var newPath = twoPath[0].exclude(twoPath[1]);
            // var newPath = twoPath[0].divide(twoPath[1])
            this.props.updateItem(this._firstSelectedItem, {
              pathData: newPath.getPathData(),
              selected: true,
              relatedCurvePoints: newPath.getSegments().map((seg) => {
                return { x: seg.point.x, y: seg.point.y };
              })
            });

            this.props.removeItem(this._secondSelectedItem);
          default:
            break;
        }
      }
    };

    keyUp = (e) => {
      const { key } = e;
      if (this._item && this._changed && key !== "shift") {
        if (this._updateTimeout) {
          clearTimeout(this._updateTimeout);
        }
        this._updateTimeout = setTimeout(() => {
          this.props.updateItem(this._item, {
            pathData: this._item.getPathData(),
            selected: true,
            relatedCurvePoints: this._item.getSegments().map((seg) => {
              return { x: seg.point.x, y: seg.point.y };
            })
          });
          this._changed = false;
          this._updateTimeout = null;
        }, 350);
      }
    };

    mouseDown = (e) => {
      this._tool = e.tool;

      e.tool.view._project.layers[2]._children.forEach((element) => {
        element.fillColor._canvasStyle = "rgb(255,255,255,0.05)";
        element.opacity = 1;
      });

      this.deselectItem();
      const hit = e.tool.view._project.hitTest(e.point, HIT_TEST_OPTIONS);
      if (hit && hit.item && !hit.item.locked) {
        if (hit.type === "segment") {
          this._segment = hit.segment;
        }

        hit.item.fillColor = hit.item.strokeColor._canvasStyle;
        hit.item.opacity = 0.5;

        this.selectItem(hit.item.data);
        hit.item.bringToFront();
        this._item = hit.item;
        this._point = e.point;
      } else {
        this._item = null;
        this._point = null;
        this.deselectItems();
      }
    };

    mouseDrag = (e) => {
      if (this.state.selectedItems.length == 0) {
        if (this._segment) {
          this._segment.point.x += e.delta.x;
          this._segment.point.y += e.delta.y;
        } else if (this._item && this._point) {
          this._item.translate(e.point.subtract(this._point));
        }

        this._changed = true;
        this._point = e.point;
      }
    };

    mouseUp = (e) => {
      if (this._segment) {
        if (e.event.shiftKey) {
          this._item.removeSegment(this._segment.index);
        }
      } else if (this._item) {
        if (e.event.ctrlKey) {
          const hit = e.tool.view._project.hitTest(e.point, HIT_TEST_OPTIONS);
          if (hit.location && this.state.selectedItems.length == 0) {
            this._item.insert(hit.location.segment.index + 1, e.point);
          } else {
            this.deselectItem();
            this.selectItems(this._item.data);
          }
        }
      }

      if (this._changed && this._item) {
        this.props.updateItem(this._item, {
          pathData: this._item.getPathData(),
          selected: true,
          relatedCurvePoints: this._item.getSegments().map((seg) => {
            return { x: seg.point.x, y: seg.point.y };
          })
        });
      }

      this._changed = false;
      this._point = null;
      this._segment = null;
    };

    render() {
      return (
        <WrappedComponent
          {...this.props}
          {...this.state}
          selectItem={this.selectItem}
          deselectItem={this.deselectItem}
          selectToolKeyDown={this.keyDown}
          selectToolKeyUp={this.keyUp}
          selectToolMouseDown={this.mouseDown}
          selectToolMouseDrag={this.mouseDrag}
          selectToolMouseUp={this.mouseUp}
        />
      );
    }
  };
}
